import { useNavigate } from 'react-router-dom'

import * as api from 'api/api'
import { tx } from 'lib/i18n'
import { useAsync } from 'lib/hooks'

import { useActiveProject } from '../context/ActiveProjectContext'
import { useRegion } from '../context/RegionContext'

export const ProjectSwitcher = () => {
  const navigate = useNavigate()
  const { locale } = useRegion()
  const activeProject = useActiveProject()
  const { data: projects } = useAsync(api.fetchProjects, [])

  return (
    <select
      className="input shell__project-switch"
      aria-label={tx(locale, 'التبديل بين المشاريع', 'Switch project')}
      value={activeProject?.id ?? ''}
      onChange={(event) => navigate(event.target.value ? `/projects/${event.target.value}` : '/')}
    >
      <option value="">{tx(locale, 'كل المشاريع', 'All projects')}</option>
      {(projects ?? []).map((project) => (
        <option key={project.id} value={project.id}>
          {project.name}
        </option>
      ))}
    </select>
  )
}
